import { ChevronDown } from "lucide-react"

// A bouncing chevron: there is more below in this scrolling pane. Pair with
// `useScrollHint`, which says when to show it. The pane's wrapper must be
// `relative`. Over text it sits on a fade; over a picture (`badge`) it sits in
// its own small disc instead, so the picture stays untouched.
export function ScrollHintArrow({ badge = false }: { badge?: boolean }) {
  if (badge) {
    return (
      <div
        aria-hidden
        className="pointer-events-none absolute inset-x-0 bottom-2 flex justify-center"
      >
        {/* The disc bounces with its chevron, so the chevron never leaves it. */}
        <span className="bg-background flex size-7 animate-bounce items-center justify-center rounded-full shadow-md motion-reduce:animate-none">
          <ChevronDown className="text-muted-foreground size-4" />
        </span>
      </div>
    )
  }
  return (
    <div
      aria-hidden
      className="from-background pointer-events-none absolute inset-x-0 bottom-0 flex justify-center bg-gradient-to-t to-transparent pt-6 pb-1"
    >
      <ChevronDown className="text-muted-foreground size-4 animate-bounce motion-reduce:animate-none" />
    </div>
  )
}
